export default {
  default: () => import("/home/runner/work/sukrit-ecosystem-monorepo/sukrit-ecosystem-monorepo/apps/naamdeo-webapp/layouts/default.vue").then(m => m.default || m)
}